import { useState } from 'react';

export default function useTrigger(initialState = false) {
	const [state, setState] = useState(initialState);

	return [
		state,
		{
			open: () => setState(true),
			close: () => setState(false),
			toggle: () => setState(prevState => !prevState)
		}
	] as const;
}
